"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Button_1 = __importDefault(require("../../Button"));
var useStyles_1 = __importDefault(require("./useStyles"));
var DialogActions = function (props) {
    var actionsBtns = props.actionsBtns, controlBtns = props.controlBtns, labelCancel = props.labelCancel, disableButtonClose = props.disableButtonClose, onClose = props.onClose, labelOk = props.labelOk, onOk = props.onOk, isValid = props.isValid, isLoading = props.isLoading, buttonOkId = props.buttonOkId, buttonCloseId = props.buttonCloseId, okButtonContainerProps = props.okButtonContainerProps, cancelButtonContainerProps = props.cancelButtonContainerProps, _a = props.okButtonFullWidth, okButtonFullWidth = _a === void 0 ? false : _a, actionButtons = props.actionButtons;
    var _b = (okButtonContainerProps || {}).breakpoints, okButtonContainerBreakpoints = _b === void 0 ? {} : _b;
    var _c = (cancelButtonContainerProps || {}).breakpoints, cancelButtonContainerBreakpoints = _c === void 0 ? {} : _c;
    var internalClasses = (0, useStyles_1.default)();
    if (!(actionsBtns || controlBtns || (!!onClose && labelCancel) || onOk) || !!actionButtons)
        return null;
    return (react_1.default.createElement(DialogActions_1.default, null,
        react_1.default.createElement(Grid_1.default, { container: true },
            actionsBtns && react_1.default.createElement(Grid_1.default, { item: true, xs: 6 }, actionsBtns),
            react_1.default.createElement(Grid_1.default, { item: true, xs: actionsBtns ? 6 : 12 },
                react_1.default.createElement(Grid_1.default, { container: true, justify: "flex-end", alignItems: "center", spacing: 2, classes: { container: internalClasses.controlBtnsContainer } },
                    controlBtns && react_1.default.createElement(Grid_1.default, { item: true, xs: 6 }, controlBtns),
                    labelCancel && (react_1.default.createElement(Grid_1.default, __assign({ item: true }, cancelButtonContainerBreakpoints),
                        react_1.default.createElement(Button_1.default, { onClick: onClose, color: "default", id: buttonCloseId, disabled: disableButtonClose }, labelCancel))),
                    onOk && (react_1.default.createElement(Grid_1.default, __assign({ item: true }, okButtonContainerBreakpoints),
                        react_1.default.createElement(Button_1.default, { onClick: onOk, disabled: !isValid, isLoading: isLoading, color: "primary", id: buttonOkId, fullWidth: okButtonFullWidth }, labelOk))))))));
};
exports.default = DialogActions;
